class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", false);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent("variant-change", {
        bubbles: true,
        variant: this.currentVariant,
        detail: {
          variant: this.currentVariant,
        },
      })
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");
        if (this.currentVariant) {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }

        // Update the inventory quantity hidden input
        const inventoryQtyDestination = document
          .querySelector(`#product-form-${this.dataset.section}`)
          .querySelector('input[name="inventory_quantity"]');
        const inventoryQtySource = html
          .querySelector(`#product-form-${this.dataset.section}`)
          .querySelector('input[name="inventory_quantity"]');
        inventoryQtyDestination.value = inventoryQtySource.value;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.triggers = this.querySelectorAll("[data-variant-selector-toggle]");
    this.wrapper = this.querySelector("[data-variant-selector-wrapper]");
    this.productForm =
      this.closest("product-info")?.querySelector("product-form");

    this.querySelectorAll("input").forEach((radio) => {
      radio.addEventListener("click", this.toggle.bind(this, radio));
      radio.addEventListener("click", () => this.selectVariant(radio));
    });

    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", this.toggle.bind(this, trigger));
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    this.options = fieldsets.map((fieldset) => {
      let checked = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );

      if (checked) {
        if (
          Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked
          ).value
        ) {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked
          ).value;
        }
      }
    });
  }

  selectVariant(variant) {
    const selectedVariant = variant
      .closest("fieldset")
      .querySelector("[data-variant-selector-selected-option]");

    const variantError = variant
      .closest("fieldset")
      .querySelector("[data-variant-error]");
    const variantErrorMobile = document.querySelector(
      "[data-variant-error-mobile]"
    );

    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    let optionsToSelect = 0;
    let optionsSelected = 0;

    fieldsets.forEach((fieldset) => {
      if (fieldset.style.display != "none") {
        optionsToSelect++;

        const selected = Array.from(
          fieldset.querySelectorAll('input[type="radio"]')
        ).some((radio) => radio.checked);

        if (selected) {
          optionsSelected++;
        }
      }
    });

    // if all options are selected
    if (optionsToSelect === optionsSelected) {
      this.productForm.classList.remove("product-form--no-choice");
    }

    variantError.classList.remove("product-variant-selector--error-visible");
    variantErrorMobile.classList.remove(
      "product-variant-selector--error-visible"
    );

    selectedVariant.textContent = variant.value;
  }

  toggle(trigger) {
    const variantOptionsWrapper = trigger.closest(
      "[data-variant-selector-wrapper]"
    );
    if (window.innerWidth < 768) {
      variantOptionsWrapper.classList.toggle("product__variant-selector--open");
      document
        .querySelector("body")
        .classList.toggle("product-variant-selector-is-open");
    }
  }
}

if (!customElements.get("variant-radios")) {
  customElements.define("variant-radios", VariantRadios);
}
